var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wifi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.12 24.83c0.709 0.725 0.709 1.901 0 2.626-0.665 0.68-1.716 0.722-2.429 0.127l-0.138-0.127c-0.81-0.829-2.096-0.875-2.959-0.138l-0.148 0.138c-0.709 0.725-1.858 0.725-2.567 0s-0.709-1.901 0-2.626c2.276-2.328 5.965-2.328 8.241 0zM25.794 19.026c0.709 0.725 0.709 1.901 0 2.626s-1.858 0.725-2.567 0c-3.992-4.083-10.463-4.083-14.455 0-0.709 0.725-1.858 0.725-2.567 0s-0.709-1.901 0-2.626c5.409-5.534 14.18-5.534 19.589 0zM31.468 13.221c0.709 0.725 0.709 1.901 0 2.626s-1.858 0.725-2.567 0c-7.125-7.289-18.677-7.289-25.803 0-0.709 0.725-1.858 0.725-2.567 0s-0.709-1.901 0-2.626c8.543-8.739 22.394-8.739 30.937 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.d2c37026dd8ac794eacd60dda638de35.svg";
export { ForwardRef as ReactComponent };